export default {
  url: process.env.REACT_APP_API_URL || '/'
  // clientId: process.env.REACT_APP_CLIENT_ID || '',
  // clientSecret: process.env.REACT_APP_CLIENT_SECRET || ''
};
